import WorkingMessage from '@/components/workflow/WorkingMessage';
import { ResponseFeedback } from '@/components/form-kit';
import {
  BULK_CREDENTIAL_ISSUE_NEXT_STEPS,
  bulkCredentialIssueSuccessIntro,
  bulkCredentialIssuingLabel,
} from '@/config/bulkUserImportFlow';

export type BulkCredentialIssuePhase = 'idle' | 'preparing' | 'issuing' | 'complete';

interface BulkCredentialIssueFollowUpProps {
  phase: BulkCredentialIssuePhase;
  count: number;
  siteLabel: string;
}

export function BulkCredentialIssueFollowUp({
  phase,
  count,
  siteLabel,
}: BulkCredentialIssueFollowUpProps) {
  if (phase === 'idle') return null;

  return (
    <div className="bulk-import__credential-follow-up">
      {phase === 'preparing' ? (
        <div className="flow-thread__saving-banner" aria-busy="true">
          <WorkingMessage
            phaseLabel="Preparing credentials"
            showProgressCard={false}
            showSkeleton
            showSavingSkeleton={false}
          />
        </div>
      ) : null}

      {phase === 'issuing' ? (
        <div className="flow-thread__saving-banner">
          <WorkingMessage
            phaseLabel={bulkCredentialIssuingLabel(count)}
            showProgressCard={false}
            showSkeleton={false}
            showSavingSkeleton={false}
          />
        </div>
      ) : null}

      {phase === 'complete' ? (
        <div className="flow-thread__assistant flow-thread__assistant--credential-complete">
          <p className="flow-thread__assistant-hint">
            {bulkCredentialIssueSuccessIntro(count, siteLabel)}
          </p>
          <div className="bulk-import__credential-next-steps">
            {BULK_CREDENTIAL_ISSUE_NEXT_STEPS.map((step) => (
              <button key={step.id} type="button" className="success-card__next-item">
                {step.label}
              </button>
            ))}
          </div>
          <ResponseFeedback />
        </div>
      ) : null}
    </div>
  );
}
